var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9338 8.75883C36.8289 8.43642 36.6248 8.15545 36.3506 7.9561C36.0763 7.75674 35.7461 7.64921 35.407 7.64889H31.7508V2.02389C31.7508 1.13494 31.0326 0.416748 30.1436 0.416748H10.8579C9.96898 0.416748 9.25079 1.13494 9.25079 2.02389V7.64889H5.59454C5.25531 7.64844 4.92471 7.75567 4.65033 7.95513C4.37595 8.1546 4.17196 8.43601 4.06775 8.75883L0.411499 20.0038V38.9882C0.411499 39.8771 1.12969 40.5953 2.01864 40.5953H38.9829C39.8719 40.5953 40.5901 39.8771 40.5901 38.9882V20.0038L36.9338 8.75883ZM12.8669 4.03282H28.1347V7.64889H12.8669V4.03282ZM36.974 36.9793H4.02757V20.5763L7.05603 11.265H33.9455L36.974 20.5763V36.9793ZM27.532 23.5194H22.1079V18.0953C22.1079 17.8743 21.9271 17.6935 21.7061 17.6935H19.2954C19.0744 17.6935 18.8936 17.8743 18.8936 18.0953V23.5194H13.4695C13.2486 23.5194 13.0678 23.7002 13.0678 23.9212V26.3319C13.0678 26.5529 13.2486 26.7337 13.4695 26.7337H18.8936V32.1578C18.8936 32.3788 19.0744 32.5596 19.2954 32.5596H21.7061C21.9271 32.5596 22.1079 32.3788 22.1079 32.1578V26.7337H27.532C27.753 26.7337 27.9338 26.5529 27.9338 26.3319V23.9212C27.9338 23.7002 27.753 23.5194 27.532 23.5194Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.3b291f2cf6773e50b315dc68d9cef084.svg";
export { ForwardRef as ReactComponent };